export const apsMenus = [
    {
        title: 'APS排程', key: 'aps_manage', icon: 'icon iconfont icon-hetongguanli-', compTypes: [2,4], children: [
            { title: '调度计划', key: '/aps/prodPlan', icon: 'icon iconfont icon-icon-test2' }
        ]
    },
];